import React, { useState, useCallback, Fragment, useEffect } from "react";
import {
  createDocument,
  getAllData,
  getById,
  updateDocumentByID,
} from "apis/customApiHandler.js";
import { useLocation } from "react-router-dom";
import { Button, Input, Select } from "styled";
import Modal from "components/Modal";
import { useFormik, Form, FormikProvider } from "formik";
import InputField from "components/formik/InputField";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";
// import { AsyncPaginate } from "react-select-async-paginate";
import { TD, TH } from "styled/table";
import Spinner from "components/Spinner";
import CustomDeletePage from "components/custom-pages/CustomDelete";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";
import { trackEvent } from "utils/analytics";

const CreateDeEnrollment = ({
  getData,
  showDeEnrollModal,
  handleClick,
  vehicleId,
}) => {
  const location = useLocation();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [selectedFleet, setSelectedFleet] = useState(null);
  const [selectedHub, setSelectedHub] = useState(null);
  const [check, setCheck] = useState(true);
  const [vehicle, setVehicle] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [saved, setSaved] = useState({});
  const [hasErrors, setHasErrors] = useState(false);
  const [disabled, setIsDisabled] = useState(false);
  const [data, setData] = useState(false);
  const [killometerTravelled, setKillometerTravelled] = useState(
    data?.killometerTravelled ?? 0
  );
  const [errors, setErrors] = useState({});

  const queryClient = useQueryClient();
  const formik = useFormik({
    initialValues: {
      odometerReading: data.odometerReading,
      killometerTravelled: killometerTravelled,
      odometerStatus: data.odometerStatus ?? true,
    },
    onSubmit: async (values) => {
      try {
        setIsDisabled(true);
        console.log("EHHERE");
        let formData = {};
        formData.deEnrolledTyres = [];
        Object.keys(values).map((key) => {
          // console.log(values[key], typeof values[key])
          // console.log(key, values[key]);
          if (typeof values[key] === "object" && values[key].deEnrolledPosition)
            formData.deEnrolledTyres.push({
              ...values[key],
              currentTotalKillometerTravelled:
                values.killometerTravelled +
                values[key].prevTotalKillometerTravelled,
              finalTyreStatus: values[key].status,
              scrapReason: values[key].scrapReason,
            });
          else {
            formData[key] = values[key];
          }
        });
        console.log({ formData });

        const Data = await createDocument("/de-enrollment", {
          ...formData,
        });
        if (Data) {
          trackDenrollEvent(ANALYTICS_EVENTS.SYS_DE_ENROLL_VEHICLE_SUCCESS, vehicle?.registrationNumber);
          toast.success("Successfully Updated");
          queryClient.invalidateQueries("inspection");
          setVehicle(null);
          setSelectedFleet(null);
          setSelectedHub(null);
        }
        setIsDisabled(false);
        handleClick();
        getData();
      } catch (error) {
        trackDenrollEvent(ANALYTICS_EVENTS.SYS_DE_ENROLL_VEHICLE_ERROR, vehicle?.registrationNumber,error?.message);
        setIsDisabled(false);
        return null;
      }
    },

    validate: (values) => {
      Object.keys(values).map((key) => {
        let allNull = true;
        const arr = ["G1", "G2", "G3", "G4"];
        if (typeof values[key] === "object") {
          // set scrap reason and status errors
          // console.log(values[key])
          // if (!values[key]["scrapReason"]){if(!errors[key]) errors[key] = {}; errors[key]["scrapReason"] = "Required";}
          // console.log(initialValues)
          arr.map((fieldName) => {
            console.log(initialValues[key][fieldName])
            const value = values[key] && values[key][fieldName];
            if (
              initialValues[key] === undefined ||
              initialValues[key][fieldName] === null||
              initialValues[key][fieldName] === undefined ||
              initialValues[key][fieldName] === "" ||
              initialValues[key][fieldName] === "0"
            ){
              console.log("In Return")
              return;
            }if (
              initialValues[key] &&
              parseFloat(initialValues[key][fieldName]) &&
              parseFloat(value) > parseFloat(initialValues[key][fieldName])
            ) {
              if (!errors[key]) errors[key] = {};
              // console.log(
              //   parseFloat(initialValues[key]),
              //   parseFloat(value) > parseFloat(initialValues[key][fieldName])
              // );
              errors[key][fieldName] = "Cannot be greater than previous value";
              console.log(
                { errors },
                parseFloat(value) > parseFloat(initialValues[key][fieldName])
              );
              allNull = false;
            } else if (!value && initialValues[key] != 0) {
              if (!errors[key]) errors[key] = {};
              errors[key][fieldName] = "Required";
              allNull = false;
            } else {
              if (!errors[key]) errors[key] = {};
              errors[key][fieldName] = null;
            }
          });
          if (!values[key]["status"]) {
            if (!errors[key]) errors[key] = {};
            errors[key]["status"] = "Required";
          }
          if (values[key]["status"]?.toUpperCase() === "SCRAP") {
            // console.log("values.key.scrapReason", values[key]["scrapReason"]);
            if (values[key]["scrapReason"] === undefined) {
              if (!errors[key]) errors[key] = {};
              errors[key]["scrapReason"] = "Required";
              allNull = false;
            }
            // console.log("ERROR", errors[key]["scrapReason"]);
          }
        }

        if (
          allNull ||
          errors[key] === undefined ||
          !Object.keys(errors[key])?.length
        )
          delete errors[key];
        // console.log(key, errors[key]?.scrapReason);
      });

      if (values.odometerStatus && !values.odometerReading)
        errors.odometerReading = "Required";

      if (values.odometerStatus && !values.odometerReading)
        errors.odometerReading = "Required";

      if (!values.hub)
        errors.hub = "Required";


      // if (!values.killometerTravelled) errors.killometerTravelled = "Required";
      if (values.killometerTravelled < 0)
        if (formik.values.odometerStatus)
          errors.killometerTravelled =
            "Odometer Reading should be greater than previous value";
        else errors.killometerTravelled = "Please enter a Positive value";

      console.log("ERRORS", { errors });
      if (!Object.keys(errors)?.length) setHasErrors(false);
      else setHasErrors(true);
      return errors;
    },
  });

  const trackDenrollEvent = (eventName,vehicleNumber,errMsg=null) => {
    return trackEvent(eventName,"Vehicles",location.pathname,{vehicle_number:vehicleNumber,errMsg:errMsg})
  }

  const { data: allFleet } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
      // ignoreAssignedHubs: true,
    })
  );
  const { data: allScrapReasons } = useQuery([`/scrap-reason`], () =>
    getAllData("/scrap-reason", {
      limit: 250,
      page: 1,
    })
  );
  const { data: allTyreLocations } = useQuery([`/tyre-location`], () =>
    getAllData("/tyre-location", {
      limit: 250,
      page: 1,
    })
  );
  // console.log({allScrapReasons})
  const getFleetOptions = useCallback(() => {
    if (allFleet && allFleet.data && allFleet.data.length) {
      return [
        ...allFleet?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleet, selectedFleet]);

  console.log('allHubs--',allHubs);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      if (!selectedFleet) {
        return allHubs.data.map((hub) => ({
          value: hub._id,
          label: hub.hubName,
        }));
      }
  
      const selectedFleetsVal = allFleet?.data?.filter(
        (fleet) => fleet._id === selectedFleet?._id
      );
  
      if (!selectedFleetsVal || selectedFleetsVal.length === 0) {
        return [];
      }
  
      return allHubs.data
        .filter((hub) =>
          selectedFleetsVal.some((fleet) => fleet.fleetCode === hub.fleetCode)
        )
        .map((hub) => ({
          value: hub._id,
          label: hub.hubName,
        }));
    }
  }, [allFleet, allHubs, selectedFleet]);
  
  const getScrapOptions = useCallback(() => {
    if (
      allScrapReasons &&
      allScrapReasons.data &&
      allScrapReasons.data.length
    ) {
      return [
        ...allScrapReasons?.data?.map((reason) => {
          return {
            value: reason._id,
            label: reason.reason,
          };
        }),
      ];
    }
  }, [allScrapReasons]);

  const getTyreLocations = useCallback(() => {
    if (
      allTyreLocations &&
      allTyreLocations.data &&
      allTyreLocations.data.length
    ) {
      return [
        ...allTyreLocations?.data?.map((tyreLocation) => {
          return {
            value: tyreLocation.name,
            label: tyreLocation.name,
          };
        }),
      ];
    }
  }, [allTyreLocations]);

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    console.log("here");
    const response = await getAllData("/vehicle", {
      fleets: selectedFleet.value,
      hub: selectedHub.value,
      page: page,
      limit: 20,
      searchQuery: searchQuery.toUpperCase(),
      status: "ASSIGNED",
    });
    return {
      options: response.data,
      hasMore: response.data?.length
        ? response.paginate.currentPage !== response.paginate.totalPage
        : false,
    };
  };
  // console.log(formik.values)
  const updateNSD = (stencilNo, name, value) => {
    formik.setFieldValue(name, value);
    console.log(stencilNo, name, value);

    let obj = { ...formik.values };
    
    const fieldName = name.split(".")[1];
    const fieldNameStencil = name.split(".")[0];

    // Update the nested field dynamically
    obj = {
      ...obj, 
      [fieldNameStencil]: {
        ...obj[fieldNameStencil],
        [fieldName]: value
      }
    };

    console.log("Updated field name:", fieldName);
    console.log("Updated object:", obj[fieldNameStencil]);

    const arr = ["G1", "G2", "G3", "G4"];
    let sum = arr.reduce((acc, nsd) => {
      return acc + (nsd === fieldName ? parseFloat(value) : parseFloat(obj[stencilNo][nsd]) || 0);
    }, 0);

    // Determine count based on G4's presence
    const count = obj[stencilNo]["G4"] && obj[stencilNo]["G4"] !== "0" ? 4 : 3;


    // Calculate and update the average NSD
    const averageNSD = (sum / count).toFixed(2);
    formik.setFieldValue(`${stencilNo}.averageNSD`, averageNSD);
  };


  useEffect(()=>{

  }, [formik.values])

  const handleVehicleUpdate = async () => {
    let initials = {};
    const getVehicle = await getById("/vehicle", vehicleId);
    // console.log(getVehicle.data);
    const selectedVehicle = getVehicle.data;
    selectedVehicle.tyres.map((tyre) => {
      // console.log(tyre.stencilNo);
      initials[tyre.stencilNo] = {
        G1: tyre.G1 && tyre.G1!== "" ? tyre.G1  : tyre.averageNSD,
        G2: tyre.G2 && tyre.G2!== "" ? tyre.G2  : tyre.averageNSD,
        G3: tyre.G3 && tyre.G3!== "" ? tyre.G3  : tyre.averageNSD,
        G4: tyre.G4 && tyre.G4!== "" ? tyre.G4  : undefined,
        averageNSD: tyre.averageNSD,
        status: "REUSE",
        tyre: tyre._id,
        prevTotalKillometerTravelled: tyre.totalKillometerTravelled,
        deEnrolledPosition: tyre.position,
      };
    });
    initials["configuration"] = selectedVehicle.configuration?._id;
    initials["fleet"] = selectedVehicle.fleet;
    // initials["hub"] = selectedVehicle.hub?._id;
    initials["vehicle"] = selectedVehicle?._id;
    initials["odometerReading"] = selectedVehicle?.odometerReading;
    initials["killometerTravelled"] = 0;
    initials["odometerStatus"] =
      selectedVehicle?.odometerStatus !== undefined
        ? selectedVehicle?.odometerStatus
        : true;
    initials["deEnrollmentDate"] = new Date().toUTCString();
    setVehicle(selectedVehicle);
    setSelectedFleet(selectedVehicle.fleet);
    // setSelectedHub({
    //   value: selectedVehicle.hub?._id,
    //   label: selectedVehicle.hub?.hubNamw,
    // });
    setInitialValues({ ...initials });
    setErrors({});
    console.log({initials})
    formik.setValues({ ...initials });
  };
  useEffect(() => {
    handleVehicleUpdate();

    return () => {
      console.log("cleaned up");
      setVehicle(null);
      handleClick();
    };
  }, [vehicleId]);

  // console.log(formik.values)
  return (
    <Fragment>
      {showDeEnrollModal && (
        <Modal
          handleClick={() => handleClick()}
          title={
            "Vehicle De-Enrolment: " + vehicle?.registrationNumber ??
            "Loading..."
          }
          className="max-w-3xl"
        >
          <div>
            <div className="w-full px-8 flex justify-center items-center gap-4"></div>
            <div className="p-5">
              <div className="w-full px-5">
                <FormikProvider value={formik}>
                  {/* <label>
              Please select a Vehicle
            <AsyncPaginate
              id="companyId"
              loadOptions={loadOptions}
              value={vehicle}
              getOptionValue={(option) => option._id}
              getOptionLabel={(option) => option?.tyres?.length ? option.registrationNumber: option.registrationNumber + "De-Enrolled"}
              onChange={async (vehicle)=>{
                formik.setValues({})
                let initials = {}
                const getVehicle = await getById("/vehicle", vehicleId);
                console.log(getVehicle.data)
                const selectedVehicle= getVehicle.data
                selectedVehicle.tyres.map(tyre=>{
                  console.log(tyre.stencilNo)
                  initials[tyre.stencilNo]= {G1: tyre.G1, G2: tyre.G2, G3: tyre.G3, G4: tyre.G4 ?? undefined, averageNSD: tyre.averageNSD, status: "REUSE", tyre: tyre._id, prevTotalKillometerTravelled: tyre.totalKillometerTravelled, deEnrolledPosition: tyre.position, }
                })
                initials["configuration"] = selectedVehicle.configuration?._id
                initials["fleet"] = selectedVehicle.fleet
                initials["hub"] = selectedVehicle.hub?._id
                initials["vehicle"] = selectedVehicle?._id
                initials["odometerReading"] = selectedVehicle?.odometerReading
                initials["killometerTravelled"] = 0
                initials["odometerStatus"] = selectedVehicle?.odometerStatus!== undefined ? selectedVehicle?.odometerStatus : true
                initials["deEnrollmentDate"] = new Date().toUTCString()
                setVehicle(selectedVehicle)
                setInitialValues({...initials})
                setErrors({})
                formik.setValues({...initials})
              }}
              additional={{
                page: 1,
              }}
              isSearchable={true}
              placeholder="Select an option"
              debounceTimeout={500}
            />
            </label> */}
                  {vehicle !== null ? (
                    <>
                      <Form className="text-gray-700 text-base w-full grid gap-2">
                        {!false && (
                          <div className="block">
                            <label className="w-full py-3">
                              Select Hub
                              <ReactSelect
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    borderColor: "transparent",
                                    minWidth: "100%",
                                    "&:hover": {
                                      borderColor: "rgb(34 197 94)",
                                    },
                                  }),
                                }}
                                className="shadow-md rounded-md py-1 mb-2"
                                options={getHubOptions()}
                                value={
                                  selectedHub && {
                                    value: selectedHub?.value,
                                    label: allHubs?.data?.find(
                                      (item) => item._id === selectedHub?.value
                                    )?.hubName,
                                  }
                                }
                                onChange={(value) => {
                                  setCheck(true);
                                  formik.setFieldValue("hub", value.value);
                                  console.log({ value });
                                  setSelectedHub(value);
                                }}
                                name="hub"
                                isMulti={false}
                              />
                            </label>
                            Odometer Status
                            <br />
                            <label htmlFor="odometerStatus">
                              <input
                                type="checkbox"
                                id="odometerStatus"
                                name="odometerStatus"
                                className="mt-2"
                                checked={!formik.values.odometerStatus}
                                onChange={() => {
                                  if (formik.values.odometerStatus === false) {
                                    formik.setFieldValue(
                                      "killometerTravelled",
                                      0
                                    );
                                    setKillometerTravelled(0);
                                  }
                                  formik.setFieldValue(
                                    "odometerStatus",
                                    !formik.values.odometerStatus
                                  );
                                }}
                              />{" "}
                              {"Odometer is not working properly"}
                            </label>
                            <br />
                          </div>
                        )}

                        {formik.values.odometerStatus ||
                        formik.values.odometerChanged ? (
                          <>
                            <InputField
                              desable={disabled}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "odometerReading",
                                  e.target.value
                                );
                                if (formik.values.odometerStatus)
                                  formik.setFieldValue(
                                    "killometerTravelled",
                                    parseFloat(
                                      initialValues.killometerTravelled
                                    ) +
                                      (e.target.value -
                                        parseFloat(
                                          initialValues.odometerReading
                                        ))
                                  );
                              }}
                              type="number"
                              label="Odometer Reading"
                              name="odometerReading"
                            />
                          </>
                        ) : (
                          <></>
                        )}
                        <InputField
                          desable={
                            data.odometerChanged || formik.values.odometerStatus
                          }
                          type="number"
                          label="Kilometer Travelled"
                          name="killometerTravelled"
                        />

                        {/* {formik.touched.killometerTravelled &&
              formik.errors.killometerTravelled ? (
                <p className="text-red-500 font-normal">
                  *{formik.errors.killometerTravelled}
                </p>
              ) : null} */}
                      </Form>
                      <table className="w-full my-5">
                        <thead className="bg-gray-50">
                          <tr>
                            <TH scope="col">S.N.</TH>
                            <TH scope="col">Stencil Number</TH>
                            <TH scope="col">Tyre Position</TH>
                            <TH scope="col">G1 NSD</TH>
                            <TH scope="col">G2 NSD</TH>
                            <TH scope="col">G3 NSD</TH>
                            <TH scope="col">G4 NSD</TH>
                            <TH scope="col">Average NSD</TH>
                            <TH scope="col">Tyre Location</TH>
                            <TH scope="col">Scrap Reason</TH>
                          </tr>
                        </thead>
                        <tbody>
                          {vehicle.tyres.map((tyre, index) => {
                            return (
                              <tr
                                key={tyre._id}
                                className={`${
                                  index % 2 !== 0 && "bg-gray-100"
                                }`}
                              >
                                <TD>{index + 1}</TD>
                                <TD
                                  className={`${
                                    tyre.owner
                                      ? tyre.owner === "JK"
                                        ? "text-yellow-500"
                                        : "text-blue-500"
                                      : tyre.isGrnTyre
                                      ? "text-yellow-500"
                                      : "text-blue-500"
                                  }`}
                                >
                                  {tyre?.stencilNo}
                                </TD>
                                <TD>{tyre?.position}</TD>
                                {["G1", "G2", "G3", "G4"].map((nsdField) => {
                                  // console.log("initial", tyre.stencilNo, initialValues[tyre.stencilNo] && initialValues[tyre.stencilNo][nsdField])
                                  return initialValues[tyre.stencilNo] &&
                                    !(!initialValues[tyre.stencilNo][nsdField] && initialValues[tyre.stencilNo][nsdField] !==
                                      "") ? (
                                    <TD>
                                      {
                                        <InputField
                                          desable={saved[tyre.stencilNo]}
                                          className="w-full"
                                          type="number"
                                          min={0}
                                          name={`${tyre.stencilNo}.${nsdField}`}
                                          onChange={(e) => {
                                            // console.log(e.target.name);
                                            updateNSD(
                                              tyre.stencilNo,
                                              e.target.name,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      }
                                      {/* {errors[tyre.stencilNo] && errors[tyre.stencilNo][nsdField] && <div className= "w-[100px] block break-all text-red-600"> *{errors[tyre.stencilNo][nsdField]}</div>} */}
                                    </TD>
                                  ) : (
                                    <TD>---</TD>
                                  );
                                })}
                                <TD>
                                  {parseFloat(
                                    formik.values[`${tyre.stencilNo}`]
                                      ?.averageNSD
                                  ).toFixed(2)}
                                </TD>
                                <TD>
                                  <ReactSelect
                                    options={getTyreLocations()}
                                    value={{
                                      value:
                                        formik.values[tyre.stencilNo] &&
                                        formik.values[tyre.stencilNo]["status"],
                                      label: formik.values[tyre.stencilNo]
                                        ? getTyreLocations()?.find(
                                            (d) =>
                                              d?.value ===
                                              formik.values[tyre.stencilNo][
                                                "status"
                                              ]
                                          )?.label
                                        : "NA",
                                    }}
                                    onChange={(value) => {
                                      console.log(value);
                                      formik.setFieldValue(
                                        `${tyre.stencilNo}.status`,
                                        value.value
                                      );
                                    }}
                                    name={`${tyre.stencilNo}.status`}
                                    isMulti={false}
                                  />
                                  {formik.touched[tyre.stencilNo] &&
                                    formik.errors[tyre.stencilNo] &&
                                    formik.touched[tyre.stencilNo][
                                      "status"
                                    ] && (
                                      <p className="text-red-500 font-normal">
                                        *
                                        {
                                          formik.errors[tyre.stencilNo][
                                            "status"
                                          ]
                                        }
                                      </p>
                                    )}
                                </TD>
                                <TD>
                                  {formik.values[tyre.stencilNo] &&
                                  formik.values[tyre.stencilNo]["status"] ===
                                    "SCRAP" ? (
                                    <ReactSelect
                                      options={getScrapOptions()}
                                      value={{
                                        value:
                                          formik.values[tyre.stencilNo] &&
                                          formik.values[tyre.stencilNo][
                                            "scrapReason"
                                          ],
                                        label: formik.values[tyre.stencilNo]
                                          ? getScrapOptions()?.find(
                                              (d) =>
                                                d?.value ===
                                                formik.values[tyre.stencilNo][
                                                  "scrapReason"
                                                ]
                                            )?.label
                                          : "NA",
                                      }}
                                      onChange={(value) => {
                                        console.log(value);
                                        formik.setFieldValue(
                                          `${tyre.stencilNo}.scrapReason`,
                                          value.value
                                        );
                                      }}
                                      name={`${tyre.stencilNo}.scrapReason`}
                                      isMulti={false}
                                    />
                                  ) : (
                                    <div className="text-center"> --- </div>
                                  )}
                                  {formik.touched[tyre.stencilNo] &&
                                    formik.touched[tyre.stencilNo][
                                      "scrapReason"
                                    ] && formik.errors[tyre.stencilNo] &&
                                    formik.errors[tyre.stencilNo][
                                      "scrapReason"
                                    ] && (
                                      <p className="text-red-500 font-normal">
                                        *
                                        {
                                          formik.touched[tyre.stencilNo][
                                            "scrapReason"
                                          ]
                                        }
                                      </p>
                                    )}
                                </TD>
                                {/* <TD>
                        <Button
                        disabled = {saved[tyre.stencilNo]} 
                        type="button" bgPrimary onClick={() => {setSaved({...saved, [tyre.stencilNo]: true})}}>
                          {" "}
                          Save
                        </Button>
                      </TD> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <>
                      <Spinner />
                    </>
                  )}
                  <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
                    <Button
                      type="button"
                      bgPrimary
                      disabled={disabled || hasErrors}
                      onClick={(e) => {
                        console.log(e);
                        setConfirmDialog(true);
                        // alert("Are you sure you want to De-Enroll this vehicle")
                        // formik.handleSubmit(e);
                      }}
                    >
                      {disabled ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                </FormikProvider>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {confirmDialog && (
        <>
          <style>{`
            .confirm-deenroll-modal::-webkit-scrollbar {
              width: 12px !important;
              height: 12px !important;
            }
            .confirm-deenroll-modal::-webkit-scrollbar-thumb {
              background-color: #10b981 !important;
              border-radius: 6px !important;
              border: 2px solid #e5e7eb !important;
            }
            .confirm-deenroll-modal::-webkit-scrollbar-track {
              background: #e5e7eb !important;
              border-radius: 6px !important;
            }
            .confirm-deenroll-modal::-webkit-scrollbar-thumb:hover {
              background: #059669 !important;
            }
          `}</style>
          <Modal handleClick={()=>{setConfirmDialog(false)}} title={"Confirm De-Enrolment"} className="max-w-2xl">
            <div className="p-4 max-h-[70vh] overflow-y-auto confirm-deenroll-modal" style={{
              scrollbarWidth: 'thin',
              scrollbarColor: '#10b981 #e5e7eb'
            }}>
              <p className="p-5 text-center">
                Are you sure you want to de-enrol vehicle: {vehicle?.registrationNumber}
              </p>

              <div className="px-5 flex justify-end items-center gap-4 pb-4 flex-wrap sm:w-full">
                <Button bgSecondary onClick={()=>{ setConfirmDialog(false) }}>
                  No
                </Button>
                <Button type="button" bgPrimary onClick={() => {trackDenrollEvent(ANALYTICS_EVENTS.CLICK_DENROLL_BUTTON, vehicle?.registrationNumber); formik.handleSubmit(); setConfirmDialog(false)}}>
                  Yes
                </Button>
              </div>
            </div>
          </Modal>
        </>
      )}
    </Fragment>

    //   </Modal>
  );
};

export default CreateDeEnrollment;
